"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var utils_1 = require("../utils");

var entities_1 = require("../entities");
/**
 * @hidden
 */


exports.createRefreshStoFactoryResolver = function (factories, symbol, stoType, stoAddress) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var securityTokenId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              securityTokenId = entities_1.SecurityToken.generateId({
                symbol: symbol
              });
              _context.t0 = stoType;
              _context.next = _context.t0 === types_1.StoType.Simple ? 4 : _context.t0 === types_1.StoType.Tiered ? 5 : 6;
              break;

            case 4:
              return _context.abrupt("return", factories.simpleStoFactory.refresh(entities_1.SimpleSto.generateId({
                securityTokenId: securityTokenId,
                stoType: stoType,
                address: stoAddress
              })));

            case 5:
              return _context.abrupt("return", factories.tieredStoFactory.refresh(entities_1.TieredSto.generateId({
                securityTokenId: securityTokenId,
                stoType: stoType,
                address: stoAddress
              })));

            case 6:
              return _context.abrupt("return", undefined);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
/**
 * Procedure that finalizes an STO
 */


var FinalizeSto =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(FinalizeSto, _Procedure_1$Procedur);

  function FinalizeSto() {
    var _this2;

    _classCallCheck(this, FinalizeSto);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(FinalizeSto).apply(this, arguments));
    _this2.type = types_1.ProcedureType.FinalizeSto;
    return _this2;
  }
  /**
   * @hidden
   */


  _createClass(FinalizeSto, [{
    key: "checkTransferStatus",
    value: function checkTransferStatus(statusCode, fromAddress, symbol, to, reasonCode, amount) {
      if (statusCode !== contract_wrappers_1.TransferStatusCode.TransferSuccess) {
        throw new PolymathError_1.PolymathError({
          code: types_1.ErrorCode.ProcedureValidationError,
          message: "Treasury wallet \"".concat(to, "\" is not cleared to receive the remaining ").concat(amount, " \"").concat(symbol, "\" tokens from \"").concat(fromAddress, "\". Please review transfer restrictions regarding this wallet address before attempting to finalize the STO. Possible reason: \"").concat(reasonCode, "\"")
        });
      }
    }
    /**
     * Finalize the STO
     *
     * Note this procedure will fail if:
     * - The specified STO address is invalid
     * - The STO has not been launched or the module has been archived
     * - Attempting to finalize a Simple STO with version 3.0.0 or less
     * - The specified STO type is invalid
     * - The STO has already been finalized
     * - The STO's treasury wallet does not clear all transfer restrictions
     */

  }, {
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var context, args, stoAddress, stoType, symbol, contractWrappers, factories, currentWallet, securityToken, stoModuleError, stoModule, remainingTokens, _ref, totalTokensSold, cap, _ref2, tokensSold, capPerTier, totalCap, _ref3, _ref4, isFinalized, treasuryWallet, address, _ref5, statusCode, reasonCode;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                context = this.context, args = this.args;
                stoAddress = args.stoAddress, stoType = args.stoType, symbol = args.symbol;
                contractWrappers = context.contractWrappers, factories = context.factories, currentWallet = context.currentWallet;
                /*
                 * Validation
                 */

                _context2.prev = 3;
                _context2.next = 6;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 6:
                securityToken = _context2.sent;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](3);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 12:
                if (utils_1.isValidAddress(stoAddress)) {
                  _context2.next = 14;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.InvalidAddress,
                  message: "Invalid STO address ".concat(stoAddress)
                });

              case 14:
                stoModuleError = new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "STO ".concat(stoAddress, " is either archived or hasn't been launched")
                });
                _context2.t1 = stoType;
                _context2.next = _context2.t1 === types_1.StoType.Simple ? 18 : _context2.t1 === types_1.StoType.Tiered ? 32 : 45;
                break;

              case 18:
                _context2.next = 20;
                return contractWrappers.moduleFactory.getModuleInstance({
                  name: contract_wrappers_1.ModuleName.CappedSTO,
                  address: stoAddress
                });

              case 20:
                stoModule = _context2.sent;

                if (stoModule) {
                  _context2.next = 23;
                  break;
                }

                throw stoModuleError;

              case 23:
                if (!contract_wrappers_1.isCappedSTO_3_0_0(stoModule)) {
                  _context2.next = 25;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.IncorrectVersion,
                  message: 'Capped STO version is 3.0.0. Version 3.1.0 or greater is required for forced finalization'
                });

              case 25:
                _context2.next = 27;
                return stoModule.getSTODetails();

              case 27:
                _ref = _context2.sent;
                totalTokensSold = _ref.totalTokensSold;
                cap = _ref.cap;
                remainingTokens = cap.minus(totalTokensSold);
                return _context2.abrupt("break", 46);

              case 32:
                _context2.next = 34;
                return contractWrappers.moduleFactory.getModuleInstance({
                  name: contract_wrappers_1.ModuleName.UsdTieredSTO,
                  address: stoAddress
                });

              case 34:
                stoModule = _context2.sent;

                if (stoModule) {
                  _context2.next = 37;
                  break;
                }

                throw stoModuleError;

              case 37:
                _context2.next = 39;
                return stoModule.getSTODetails();

              case 39:
                _ref2 = _context2.sent;
                tokensSold = _ref2.tokensSold;
                capPerTier = _ref2.capPerTier;
                totalCap = capPerTier.reduce(function (prev, next) {
                  return prev.plus(next);
                }, new contract_wrappers_1.BigNumber(0));
                remainingTokens = totalCap.minus(tokensSold);
                return _context2.abrupt("break", 46);

              case 45:
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "Invalid STO type ".concat(stoType)
                });

              case 46:
                _context2.next = 48;
                return Promise.all([stoModule.isFinalized(), contractWrappers.getTreasuryWallet({
                  module: stoModule
                })]);

              case 48:
                _ref3 = _context2.sent;
                _ref4 = _slicedToArray(_ref3, 2);
                isFinalized = _ref4[0];
                treasuryWallet = _ref4[1];

                if (!isFinalized) {
                  _context2.next = 54;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "STO ".concat(stoAddress, " has already been finalized")
                });

              case 54:
                _context2.next = 56;
                return currentWallet.address();

              case 56:
                address = _context2.sent;
                _context2.next = 59;
                return securityToken.canTransfer({
                  to: treasuryWallet,
                  value: remainingTokens
                });

              case 59:
                _ref5 = _context2.sent;
                statusCode = _ref5.statusCode;
                reasonCode = _ref5.reasonCode;
                this.checkTransferStatus(statusCode, address, symbol, treasuryWallet, reasonCode, remainingTokens);
                /*
                 * Transactions
                 */

                _context2.next = 65;
                return this.addTransaction(stoModule.finalize, {
                  tag: types_1.PolyTransactionTag.FinalizeSto,
                  resolvers: [exports.createRefreshStoFactoryResolver(factories, symbol, stoType, stoAddress)]
                })({});

              case 65:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9]]);
      }));
    }
  }]);

  return FinalizeSto;
}(Procedure_1.Procedure);

exports.FinalizeSto = FinalizeSto;